export default __webpack_public_path__ + "static/media/checkmark.e2c6893c.svg";